import React from 'react';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Modal,
  useMediaQuery,
  useTheme,
  Grid,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { TrainingVideoLinks } from '../../../../../types/api';

interface TrainingVideoProps {
  video: TrainingVideoLinks;
}
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Tracker } from '../../utils/tracker';

const TrainingVideo: React.FC<TrainingVideoProps> = ({ video }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const findVimeoId = (url: string): any => {
    const ids = url.split('/').slice(3).join('/');
    if (ids.split('/').length == 1)
      return { thumbnail: `${ids}.jpg`, videoId: `${ids}?` };
    const parts = ids.split('/');
    return {
      thumbnail: `${parts[0]}:${parts[1]}.jpg`,
      videoId: `${parts[0]}?h=${parts[1]}&`,
    };
  };
  const vimeoId = findVimeoId(video.url);
  const theme = useTheme();
  const isXsOrSmOrMd = useMediaQuery(theme.breakpoints.down('md'));

  const tracker = Tracker.getInstance();

  return (
    <Card
      sx={{ display: 'flex', height: 'fit-content', flexDirection: 'column' }}
      elevation={0}
    >
      <Helmet>
        <meta name="referrer" content="origin" />
      </Helmet>
      <CardContent
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          cursor: 'pointer',
          p: 1,
        }}
        onClick={() => {
          setIsOpen(true);
          tracker.trackTrainingVideoClicked(video.id, video.title);
        }}
      >
        <div style={{ position: 'relative', width: '360px', height: '200px' }}>
          <img
            src={`https://vumbnail.com/${vimeoId.thumbnail}`}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              borderRadius: '10px',
            }}
          />
          <PlayArrowIcon
            fontSize="large"
            style={{
              position: 'absolute',
              left: '46%',
              top: '46%',
              color: '#d9d9d9',
              background: 'white',
              borderRadius: '4px',
              cursor: 'pointer',
              boxShadow: '0px 2px 7px 1px #1e1e1e7a',
            }}
            sx={{
              '&:hover': {
                color: '#c9c9c9 !important',
                boxShadow: '0px 2px 7px 1px #1e1e1e !important',
              },
            }}
            onClick={() => setIsOpen(true)}
          />
          {/*  */}
        </div>
        <Box ml={2}>
          <Typography variant="h4" mt={0.5}>
            {video.title}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            fontSize={12}
            mb={1}
          >
            Last Updated:{' '}
            {new Date(video.created_at).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            })}
          </Typography>
          <Typography
            variant="body1"
            color="text.primary"
            fontSize={14}
            textOverflow="ellipsis"
            overflow="hidden"
            width={1}
            maxHeight={'66px'}
          >
            {video.description}
          </Typography>
        </Box>
      </CardContent>
      <Modal open={isOpen} onClose={() => setIsOpen(false)}>
        <Grid
          container
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            overflowY: 'scroll',
          }}
        >
          <Grid
            item
            xs={12}
            md={8}
            lg={9}
            id="inter"
            sx={{
              backgroundColor: '#5e7690',
              boxShadow: 24,
              borderRadius: 1,
              height: isXsOrSmOrMd ? '100vh' : 'max(min(500px, 70vh), 500px)',
              minHeight: 'min(500px, 100vh) !important',
              maxHeight: 'max(500px, 100vh) !important',
              width: isXsOrSmOrMd ? '100%' : '820px !important',
              maxWidth: isXsOrSmOrMd ? '100%' : '820px !important',
              position: 'relative',
              pt: 4,
              display: 'flex',
              alignItems: 'end',
              justifyContent: 'center',
            }}
          >
            <span
              style={{
                position: 'absolute',
                color: 'white',
                right: 5,
                top: 5,

                cursor: 'pointer',
              }}
              onClick={() => setIsOpen(false)}
            >
              <CancelOutlinedIcon sx={{ fontSize: 35 }} />
            </span>
            <iframe
              src={`https://player.vimeo.com/video/${vimeoId.videoId}badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479`}
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
              style={{
                width: isXsOrSmOrMd ? '100%' : '900px',
                height: isXsOrSmOrMd ? '100%' : '450px',
                borderRadius: '10px',
              }}
              title={video.title}
            ></iframe>
          </Grid>

          <script src="https://player.vimeo.com/api/player.js"></script>
        </Grid>
      </Modal>
    </Card>
  );
};

export default TrainingVideo;
